module.exports = __webpack_public_path__ + "img/free-icon-pie-chart-4215959.09f0d6cf.svg";